import React, { useEffect, useState } from "react";
import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, DatePicker, Form, Input, Select, notification, Progress } from "antd";
import "./sales_invoice_profit_report.css";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import axios from "axios";

const SalesInvoiceProfitReport: React.FC = () => {
    const [form] = Form.useForm();
    const [warehouses, setWarehouses] = useState<{ warehouse_code: string; warehouse_name: string }[]>([]);
    const [exporting, setExporting] = useState<boolean>(false);
    const startDate = Form.useWatch("start_date", form);
    const endDate = Form.useWatch("end_date", form);
    const invoiceTrans = Form.useWatch("invoice_trans", form);
    const warehouseVal = Form.useWatch("warehouse", form);
    const handleExport = async (values: any) => {
        setExporting(true);
        const key = "export_progress_notification_key";

        notification.open({
            key,
            message: "Memproses Laporan",
            description: (
                <div>
                    <div style={{ marginBottom: 8 }}>Mengumpulkan data penjualan... (0%)</div>
                    <Progress percent={0} size="small" status="active" />
                </div>
            ),
            duration: 0,
            placement: "topRight",
        });

        try {
            const startDate = values.start_date ? values.start_date.format("DD/MM/YYYY") : "";
            const endDate = values.end_date ? values.end_date.format("DD/MM/YYYY") : "";
            const warehouse = values.warehouse || "";
            const invoiceTrans = values.invoice_trans || "";

            const apiPromise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/sales-invoice-profit-report/export`, {
                params: { start_date: startDate, end_date: endDate, warehouse, invoice_trans: invoiceTrans },
                responseType: "blob",
            });

            let currentPercent = 0;
            const delayPromise = new Promise<void>((resolve) => {
                const interval = setInterval(() => {
                    currentPercent += 10;
                    if (currentPercent > 100) currentPercent = 100;

                    notification.open({
                        key,
                        message: "Memproses Laporan",
                        description: (
                            <div>
                                <div style={{ marginBottom: 8 }}>Mengekspor file Excel... ({currentPercent}%)</div>
                                <Progress percent={currentPercent} size="small" status="active" />
                            </div>
                        ),
                        duration: 0,
                        placement: "topRight",
                    });

                    if (currentPercent >= 100) {
                        clearInterval(interval);
                        resolve();
                    }
                }, 300);
            });

            const [response] = await Promise.all([apiPromise, delayPromise]);

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Sales_Invoice_Profit_Report_${startDate.replace(/\//g, "-")}_${endDate.replace(/\//g, "-")}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.parentNode?.removeChild(link);

            notification.success({
                key,
                message: "Export Laporan Berhasil",
                description: "Dokumen Excel Anda telah sukses diunduh.",
                duration: 3,
            });
        } catch (error) {
            console.error("Failed to export sales profit report:", error);
            notification.error({
                key,
                message: "Export Laporan Gagal",
                description: "Gagal memproses pembuatan berkas laporan excel.",
                duration: 4,
            });
        } finally {
            setExporting(false);
        }
    };
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };
    const Submitbtn = HiOutlineDocumentCheck as React.ComponentType<any>;
    useEffect(() => {
        const fetchWarehouses = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/sales-invoice-profit-report/warehouses`);
                setWarehouses(response.data);
            } catch (error) {
                console.error("Failed to load warehouses:", error);
            }
        };
        fetchWarehouses();
    }, []);


    return (

        <div id="ihrq" style={transformStyle}>
            <div className="gjs-grid-row" id="iz18c">
                <div className="gjs-grid-column" id="iuw84">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                title: "Invoice Profitability Report",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="ihzvr">
                <div className="gjs-grid-column" id="ib3yz">
                    <Form
                        form={form}
                        onFinish={handleExport}
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item
                            label="Start Date"
                            name="start_date"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <DatePicker format="DD/MM/YYYY" style={{ width: '50%' }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement} />
                        </Form.Item>
                        <Form.Item
                            label="End Date"
                            name="end_date"
                            style={{
                                marginBottom: "5px",
                            }}

                        >
                            <DatePicker format="DD/MM/YYYY" style={{ width: '50%' }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement} />
                        </Form.Item>
                        <Form.Item
                            label="Invoice Transaction"
                            name="invoice_trans"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Select
                                showSearch
                                placeholder=""
                                optionFilterProp="label"
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                options={[
                                    { label: "All", value: "ALL" },
                                    { label: "Invoice Spareparts", value: "SPIV" },
                                    { label: "Invoice Service", value: "WSIV" },
                                ]}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Warehouse"
                            name="warehouse"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Select
                                showSearch
                                placeholder="Pilih Warehouse"
                                optionFilterProp="label"
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                options={[
                                    { value: "ALL", label: "All" },
                                    ...warehouses.map((w) => ({ value: w.warehouse_code, label: w.warehouse_name }))
                                ]}
                            />
                        </Form.Item>
                        <Button className="gr-button" htmlType="submit" disabled={exporting || !startDate || !endDate || !invoiceTrans || !warehouseVal}>
                            <Submitbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Submit
                        </Button>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default SalesInvoiceProfitReport;
